import styled from 'styled-components';

export const ConfigureContainerStyle = styled('div')`
    font-family: 'Poppins' !important;
    background: #FFFFFF;
    width: 90%;
    margin: 20px auto;
    padding-top: 30px;
`;